import 'reflect-metadata';
import { Container } from 'inversify';
import { ServiceRegistredRecord } from './service-registred-record';
import { AppSettings } from './app-settings';

import * as Notification from './../Notification';
import * as HelpDesk from './../HelpDesk';
import * as Telegram from './../Telegram';
import * as DateHandler from './../Utility';
import * as Localization from './../Localization';
import { IContext } from '../Identity';
import { IdentitySymbols } from '../Identity/symbols';

export const GlobalSymbols = {
    GlobalService: Symbol.for("GlobalService")
}

export default class GlobalService {
    protected static _settings: AppSettings;

    static SetSettings<T extends AppSettings>(settings: T): void{
        this._settings = settings;
    }

    static GetSettings<T extends AppSettings>(): T {
        return this._settings as T;
    }

    protected _container: Container = new Container();
    protected _records: Array<ServiceRegistredRecord> = new Array<ServiceRegistredRecord>();

    Get<T>(type: symbol): T {
        return this._container.get<T>(type);
    }

    protected registerServices(redefinedServices?: Array<ServiceRegistredRecord>) {
        if (redefinedServices == null) {
            this._records.forEach(item => {
                let bind = this._container.bind(item.Key).to(item.Value);

                if (item.IsSingelton) bind.inSingletonScope();
            });

            return;
        }

        this._records.forEach(item => {
            let service = redefinedServices.find(x => x.Key == item.Key);

            if (service == null) service = item;

            let bind = this._container.bind(service.Key).to(service.Value);

            if (service.IsSingelton) bind.inSingletonScope();
        });

        this._container.bind<GlobalService>(GlobalSymbols.GlobalService).toConstantValue(this);
    }

    protected registerAllSymbols(): void {
        this._records = new Array<ServiceRegistredRecord>(
            //Notification
            new ServiceRegistredRecord(Notification.NotificationSymbols.NotificationService, Notification.DefaultNotificationService),
            //HelpDesk
            new ServiceRegistredRecord(HelpDesk.HelpDeskSymbols.HelpDeskService, HelpDesk.DefaultHelpDeskService),
            new ServiceRegistredRecord(HelpDesk.HelpDeskSymbols.HelpDeskProvider, HelpDesk.DefaultHelpDeskProvider),
            //Telegram
            new ServiceRegistredRecord(Telegram.TelegramSymbols.TelegramService, Telegram.DefaultTelegramService),
            new ServiceRegistredRecord(Telegram.TelegramSymbols.TelegramProvider, Telegram.DefaultTelegramProvider),
            //DateHandler
            new ServiceRegistredRecord(DateHandler.DateHandlerSymbols.DateHandlerService, DateHandler.DateHandlerService),
            //localization
            new ServiceRegistredRecord(Localization.LocalizationSymbols.LocalizationService, Localization.DefaultLocalizationService),
        );
    }

    protected registerAdditionalService(additionalServices: Array<ServiceRegistredRecord>) {
        additionalServices.forEach(item => {
            let bind = this._container.bind(item.Key).to(item.Value);

            if (item.IsSingelton) bind.inSingletonScope();
        });
    }

    public LoadConfiguration(context: IContext, redefinedServices?: Array<ServiceRegistredRecord>,
        additionalServices?: Array<ServiceRegistredRecord>): void {
        this._container.bind<IContext>(IdentitySymbols.Context).toConstantValue(context);

        this.registerAllSymbols();
        this.registerServices(redefinedServices);
        if (additionalServices != null)
            this.registerAdditionalService(additionalServices);
    }
}